export const CV_SHOW_MENU_AVATAR = 'CV_SHOW_MENU_AVATAR';
export const CV_HIDE_MENU_AVATAR = 'CV_HIDE_MENU_AVATAR';
export const CV_SHOW_MENU_AVATAR_MOBILE = 'CV_SHOW_MENU_AVATAR_MOBILE';
export const CV_HIDE_MENU_AVATAR_MOBILE = 'CV_HIDE_MENU_AVATAR_MOBILE';
